var FuzzyReaction = require('../bootstrap').FuzzyReaction;
var AppDispatcher = FuzzyReaction.Dispatcher;
var AppActionConstants = require('../constants/AppActionConstants');
var assign = require('object-assign');
var ModelStore = FuzzyReaction.Stores.ModelStore;

var ActionTypes = AppActionConstants.ActionTypes.users;
var GenresActionTypes = AppActionConstants.ActionTypes.genres;

/**
 * Data stores
 * @type {Array}
 * @private
 */
// Store for user table data
var _resourceListData = [];
var _resourceData = {};
var _allGenres = [];
var _instructors = [];

/**
 * User store logic
 *
 * @type {*|exports}
 */
var InstructorStore = assign({}, ModelStore, {
	getResourceListData: function () {
		return _resourceListData;
	},

	getResource: function () {
		return _resourceData;
	},

	getAllGenres: function () {
		return _allGenres;
	},

	getResourceById: function (id) {
		// http://stackoverflow.com/questions/12553274/getting-index-of-an-arrays-element-based-on-its-properties
		var index = _resourceListData.map(function(item) {
			return item.id;
		}).indexOf(Number(id));

		return _resourceListData[index];
	},

	getInstructors: function () {
		return _instructors;
	}
});

/**
 * Event Listeners
 */
InstructorStore.dispatchToken = AppDispatcher.register(function(action) {
	switch(action.type) {
		case 'INSTRUCTORS_RECEIVED':
			_resourceData = action.data;

			InstructorStore.emitChange();
			break;
		case 'INSTRUCTORS_CREATED':
			_resourceData = action.data;

			InstructorStore.emitChange();
			break;
		case 'INSTRUCTORS_LISTED':
			_resourceListData = action.data;

			InstructorStore.emitChange();
			break;
		case 'GENRES_LISTED':
			_allGenres = action.data;

			InstructorStore.emitChange();
			break;
		case 'ME_LISTED':
			_resourceData = action.data;

			InstructorStore.emitChange();
			break;
	}
});

module.exports = InstructorStore;
